/* eslint-disable class-methods-use-this */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';

import BigCalendar from './calendar';
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import '!style-loader!css-loader!react-big-calendar/lib/css/react-big-calendar.css';
import { SERVER_URL } from '../../../config';
import ActionButton from '../../common/ActionButton';
import { encodeQueryData } from '../../../api/DataHandlers';
import { ServiceDropDown } from '../common/dropdowns';
import { SelectRole } from '../../common/SelectRole';
import ClientSearch from '../common/clientsearch';
import SearchBar from '../common/SearchBar';
import StatusDropDown from './StatusDropDown';
import { withPushFiltersToUrl } from '../common/decorators';
import { fetchCalendarEvents, resetCalendar } from '../../../actions/Calendar';
import DayView from './DayView';
import WeekView from './WeekView';
import MonthView from './MonthView';
import JobsCalendarToolbar from './JobsCalendarToolBar';
import withDragAndDrop from './calendar/addons/dragAndDrop';
import './calendar/less/styles.less';

const localizer = BigCalendar.momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(BigCalendar);

@withPushFiltersToUrl
class JobsCalendarContainer extends Component {
    constructor(props) {
        super(props);
        const width = window.innerWidth;
        const isMobile = width < 900;
        this.state = {
            currentViewClass: isMobile ? 'day' : 'month',
            trackedDate: null,
            filterOpen: false,
            showFilters: !isMobile,
            width,
        };
        this.handleOnNavigate = this.handleOnNavigate.bind(this);
        this.handleOnViewChange = this.handleOnViewChange.bind(this);
        this.handleOnSelectEvent = this.handleOnSelectEvent.bind(this);
        this.handleEventPropGetter = this.handleEventPropGetter.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
        this.table = this;
        this.props.setTable(this);
        const currentUrlParams = new URLSearchParams(
            this.props.history.location.search,
        );
        if (currentUrlParams.has('page')) {
            currentUrlParams.delete('page');
        }
        const view =
            currentUrlParams.get('view') || this.state.currentViewClass;
        this.setQuery({ view });
        this.getDateFormatForApi(
            currentUrlParams.get('after')
                ? moment(currentUrlParams.get('after'))
                : moment(),
            view,
        );
        this.props.load(currentUrlParams, view);
    }

    componentDidUpdate(prevProps) {
        const currentUrlParams = new URLSearchParams(
            this.props.history.location.search,
        );
        if (
            prevProps.location.pathname === this.props.location.pathname &&
            prevProps.location.search !== this.props.location.search
        ) {
            this.props.load(currentUrlParams, currentUrlParams.get('view'));
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                filterOpen: false,
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    static childContextTypes = {
        user: PropTypes.any,
    };

    handleWindowSizeChange = () => {
        this.setState(prevState => {
            const width = window.innerWidth;
            let { currentViewClass } = this.state;
            const view = 'day';
            let { showFilters } = prevState;
            const currentUrlParams = new URLSearchParams(
                this.props.history.location.search,
            );
            if (
                prevState.width >= 900 &&
                width < 900 &&
                prevState.currentViewClass !== view
            ) {
                this.handleOnViewChange(view);
                this.props.load(currentUrlParams, view);
                currentViewClass = view;

                if (showFilters) {
                    showFilters = false;
                }
            }
            return {
                ...prevState,
                currentViewClass,
                width,
                showFilters,
            };
        });
    };

    toggleShowFilters = () => {
        this.setState(prevState => ({
            ...prevState,
            showFilters: !prevState.showFilters,
        }));
    };

    getChildContext() {
        return { user: this.props.user };
    }

    handleOnNavigate(date, view) {
        this.getDateFormatForApi(moment(date), view);
    }

    handleOnViewChange(view) {
        this.props.resetCalendar();
        this.setQuery({ view });
        this.setState({ currentViewClass: view });
        this.getDateFormatForApi(moment(this.state.trackedDate), view);
    }

    handleEventPropGetter(event) {
        let className;
        switch (event.service_key) {
            case 'hospitality':
                className = `calendar-event calendar-event-${event.role}`;
                break;
            case 'driver':
                className = `calendar-event calendar-event-d${event.vehicle_type}`;
                break;
            default:
                className = 'calendar-event';
        }
        return {
            className,
        };
    }

    handleOnSelectEvent(event) {
        if (event.id) {
            window.location = `${SERVER_URL}/job/${event.id}`;
        } else {
            const params = {
                after: moment(event.end)
                    .set({ hour: 4, minute: 0, second: 0, millisecond: 0 })
                    .toISOString(),
                before: moment(event.start)
                    .add(1, 'days')
                    .set({ hour: 3, minute: 59, second: 59, millisecond: 0 })
                    .toISOString(),
                status: event.status,
            };
            this.props.history.push(`/jobs/list?${encodeQueryData(params)}`);
        }
    }

    handleSelectSlot = ({ start, end }) => {
        const startDate = moment(start);
        const endDate = moment(end);
        const differenceFromNow = startDate.diff(moment(), 'hours', true);
        if (differenceFromNow < 4) {
            this.props.notification.error(
                'Note',
                'Please choose a date & time at least 4 hours in advance',
            );
        } else {
            const currentUrlParams = new URLSearchParams(
                this.props.history.location.search,
            );
            currentUrlParams.set('createafter', startDate.toISOString());
            currentUrlParams.set('createbefore', endDate.toISOString());
            const pathname = this.props.user.isAgent
                ? '/jobs/calendar/create'
                : '/job/create';
            this.props.history.push({
                pathname,
                search: currentUrlParams.toString(),
            });
        }
    };

    getEventComponentForMonthView = ({ event }) => <MonthView event={event} />;

    getEventComponentForWeekView = ({ event }) => <WeekView event={event} />;

    getEventComponentForDayView = ({ event }) => {
        const isMobile = this.state.width < 900;
        return <DayView event={event} isMobile={isMobile} />;
    };

    getDateFormatForApi = (date, endOf = 'week') => {
        // if day view is this week, show current day
        if (
            endOf === 'day' &&
            moment(this.state.trackedDate).isSame(moment(), 'week')
        ) {
            this.setState({ trackedDate: moment().toISOString() });
        } else {
            this.setState({ trackedDate: date.toISOString() });
        }

        const dateFilters = {
            after: date
                .startOf(endOf)
                .set({ hour: 4, minute: 0, second: 0, millisecond: 0 })
                .toISOString(),
            before: date
                .endOf(endOf)
                .add(1, 'days')
                .set({ hour: 3, minute: 59, second: 59, millisecond: 0 })
                .toISOString(),
        };

        this.setQuery(dateFilters);
    };

    moveEvent = ({ event, start }) => {
        if (!moment(start).isSame(moment(event.start))) {
            this.editEvent(event, start);
        }
    };

    editEvent = (event, start = null) => {
        const { user } = this.props;
        let isEditable = false;
        if (user.isClient) {
            isEditable = true;
            // eslint-disable-next-line eqeqeq
        } else if (event.owner_agency_details.id == this.props.user.agency.id) {
            isEditable = true;
        }

        let startDifferenceFromNow;
        let editStart;
        if (start) {
            editStart = moment(start);
            startDifferenceFromNow = editStart.diff(moment(), 'hours', true);
        }

        const eventStart = moment(event.start);
        const eventStartFromNow = eventStart.diff(moment(), 'hours', true);

        if (!isEditable) {
            this.props.notification.error('Note', 'Booking can not be edited');
        } else if (eventStartFromNow < 0) {
            this.props.notification.error(
                'Note',
                'Booking has already started or ended',
            );
        } else if (startDifferenceFromNow < 4) {
            this.props.notification.error(
                'Note',
                'Please choose a date & time at least 4 hours in advance',
            );
        } else {
            const currentUrlParams = new URLSearchParams(
                this.props.history.location.search,
            );
            if (start) {
                currentUrlParams.set('editafter', editStart.toISOString());
            }
            this.props.history.push({
                pathname: `/jobs/calendar/edit/${event.id}`,
                search: currentUrlParams.toString(),
            });
        }
    };

    setQuery = queryObject => {
        const queryKeys = Object.keys(queryObject);
        const currentUrlParams = new URLSearchParams(
            this.props.history.location.search,
        );
        queryKeys.forEach(query => {
            currentUrlParams.set(query, queryObject[query]);
        });
        this.props.history.push({
            search: currentUrlParams.toString(),
        });
    };

    handleFilterClick = () => {
        this.setState({
            filterOpen: true,
        });
    };

    handleModalClick = () => {
        this.setState({
            filterOpen: false,
        });
    };

    onCreate = () => {
        const { user, history } = this.props;
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (
            user.isClient ||
            (user.isAgent && user.agency.features.includes('booking_tunnel'))
        ) {
            history.push('/job/create');
        } else {
            history.push({
                pathname: '/jobs/calendar/create',
                search: currentUrlParams.toString(),
            });
        }
    };

    checkFiltersApplied = query => {
        const filtersFields = [
            'service',
            'status',
            'role',
            'search',
            'vehicle_type',
            'bookings_client',
        ];
        return filtersFields.find(field => query.get(field) !== null);
    };

    render() {
        const { history, location } = this.props;
        const { currentViewClass } = this.state;

        const currentUrlParams = new URLSearchParams(history.location.search);
        const filtersApplied = this.checkFiltersApplied(currentUrlParams);

        const isMobile = this.state.width < 900;
        const viewClass = currentUrlParams.get('view') || currentViewClass;

        return (
            <div
                className={`calendar-container ${viewClass} ${
                    isMobile ? 'mobile' : ''
                }`}
            >
                {this.state.filterOpen ? (
                    <div
                        className="filter-modal"
                        onClick={this.handleModalClick}
                    />
                ) : null}
                <div className="table-filter-container-outer">
                    <div
                        className="table-filter-container hidable"
                        onClick={this.handleFilterClick}
                    >
                        {!isMobile ? (
                            <div className="table-action-bar filters">
                                <div className="grouped-buttons">
                                    <StatusDropDown
                                        onFilterChange={
                                            this.props.onFilterChange
                                        }
                                        history={history}
                                        // eslint-disable-next-line no-return-assign
                                        ref={el => (this.status = el)}
                                    />
                                    <SelectRole
                                        onFilterChange={
                                            this.props.onFilterChange
                                        }
                                        currentUrlParams={currentUrlParams}
                                    />
                                    {this.props.user.isAgent ? (
                                        <ClientSearch history={history} />
                                    ) : null}
                                    <SearchBar
                                        filterKey="search"
                                        onFilterChange={
                                            this.props.onFilterChange
                                        }
                                        currentUrlParams={currentUrlParams}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="table-action-bar filters">
                                <div className="grouped-buttons">
                                    <ActionButton
                                        className="filter"
                                        active={this.state.showFilters}
                                        onAction={this.toggleShowFilters}
                                        iconClass="icon-filter-22"
                                        text={filtersApplied ? '*' : undefined}
                                        tooltip={
                                            !isMobile
                                                ? this.state.showFilters
                                                    ? 'Hide Filters'
                                                    : 'Filters'
                                                : ''
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        <div className="table-action-bar">
                            <div className="grouped-buttons">
                                <ActionButton
                                    onAction={() => this.onCreate()}
                                    text={
                                        !isMobile
                                            ? this.props.user.isClient
                                                ? 'New booking'
                                                : 'Create'
                                            : ''
                                    }
                                    tooltip={
                                        !isMobile
                                            ? this.props.user.isClient
                                                ? 'New booking'
                                                : 'Create'
                                            : ''
                                    }
                                    requiredPermission="job.add_jobrequest"
                                    iconClass="icon-add-12"
                                />
                                <ActionButton
                                    tooltip="List view"
                                    iconClass="icon-view-list"
                                    onAction={() =>
                                        history.push({
                                            pathname: '/jobs/list',
                                            search: location.search,
                                        })
                                    }
                                />
                                <ActionButton
                                    tooltip="Calendar view"
                                    iconClass="icon-calendar-1"
                                    active={true}
                                />
                            </div>
                        </div>
                    </div>
                    {isMobile && this.state.showFilters ? (
                        <div className="table-action-bar optional">
                            <StatusDropDown
                                onFilterChange={this.props.onFilterChange}
                                history={history}
                                // eslint-disable-next-line no-return-assign
                                ref={el => (this.status = el)}
                            />
                            <ServiceDropDown
                                onFilterChange={this.props.onFilterChange}
                                history={history}
                            />
                            <SelectRole
                                onFilterChange={this.props.onFilterChange}
                                history={history}
                            />
                            {this.props.user.isAgent ? (
                                <ClientSearch history={history} />
                            ) : null}
                            <SearchBar
                                filterKey="search"
                                onFilterChange={this.props.onFilterChange}
                                currentUrlParams={currentUrlParams}
                            />
                        </div>
                    ) : null}
                </div>
                <div className={`calendar-div ${viewClass}`}>
                    <DragAndDropCalendar
                        {...this.props}
                        localizer={localizer}
                        popup={true}
                        selectable={!this.state.filterOpen}
                        resizable={true}
                        draggableAccessor={() => this.props.user.isAgent}
                        onEventDrop={this.moveEvent}
                        events={this.props.calendar.events}
                        view={currentUrlParams.get('view') || currentViewClass}
                        views={['month', 'week', 'day']}
                        defaultView={
                            isMobile
                                ? 'day'
                                : currentUrlParams.get('view') ||
                                  currentViewClass
                        }
                        step={30}
                        defaultDate={
                            currentUrlParams.get('after')
                                ? new Date(currentUrlParams.get('after'))
                                : new Date()
                        }
                        onNavigate={this.handleOnNavigate}
                        onView={this.handleOnViewChange}
                        eventPropGetter={this.handleEventPropGetter}
                        onSelectEvent={this.handleOnSelectEvent}
                        onSelectSlot={this.handleSelectSlot}
                        components={{
                            month: {
                                event: this.getEventComponentForMonthView,
                            },
                            week: { event: this.getEventComponentForWeekView },
                            day: { event: this.getEventComponentForDayView },
                            toolbar: JobsCalendarToolbar,
                        }}
                        culture="en-GB"
                        messages={{
                            previous: '\ue96f',
                            today: isMobile ? 'Day' : 'Current',
                            next: '\ue97c',
                            month: 'Month',
                            week: 'Week',
                            day: 'Day',
                        }}
                        showMultiDayTimes={true}
                        scrollToTime={moment().hour(7)}
                        isMobile={isMobile}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    calendar: state.calendar,
});

const mapDispatchToProps = dispatch => ({
    load: (query, view) => dispatch(fetchCalendarEvents(query, view)),
    resetCalendar: () => dispatch(resetCalendar()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(JobsCalendarContainer);
